module.exports = __webpack_public_path__ + "img/portalmanagement_cancel_account.b2083faf.png";